export const EMPLOYMENT_ROUTES = {
  ONBOARDING_EMPLOYMENT_HISTORY: '/onboarding/employment-history/',
  ONBOARDING_EMPLOYMENT_HISTORY_ADD: '/onboarding/employment-history/add-position/',
  ONBOARDING_EMPLOYMENT_HISTORY_EDIT: '/onboarding/employment-history/edit-position/:id/',
}
